import PortalIdParser from 'PortalIdParser';
import { getFullUrl } from 'hubspot-url-utils';
const ACADEMY_BASE_URL = `${getFullUrl('app')}/academy`;
export const getAcademyRedirectUrl = () => {
  return `${ACADEMY_BASE_URL}/${PortalIdParser.getPortalIdFromPath() || 'l'}`;
};
export const getStaticLessonRedirectUrl = (lessonId, contentId, language, startTime) => {
  return `${getAcademyRedirectUrl()}/lessons/${lessonId}/${contentId}?language=${language}${startTime ? `&vts=${startTime}` : ''}`;
};
export const getStaticShortsRedirectUrl = (shortId, startTime) => {
  return `${getAcademyRedirectUrl()}/shortvideo/${shortId}${startTime ? `?vts=${startTime}` : ''}`;
};